import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import { environment } from 'src/environments/environment';

export function connectFirebaseEmulators(): void {
  const emulators = environment.firebaseEmulators;

  if (!emulators) {
    return;
  }

  firebase.auth().useEmulator(emulators.auth);
  (firebase.database() as any).useEmulator('localhost', 9000);
  (firebase.storage() as any).useEmulator('localhost', 9199);
}
